/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GenerationInputsPolymorphicConversationalAgentGenerationInputs } from './GenerationInputsPolymorphicConversationalAgentGenerationInputs';
import {
  GenerationInputsPolymorphicConversationalAgentGenerationInputsFromJSON,
  GenerationInputsPolymorphicConversationalAgentGenerationInputsFromJSONTyped,
  GenerationInputsPolymorphicConversationalAgentGenerationInputsToJSON,
} from './GenerationInputsPolymorphicConversationalAgentGenerationInputs';
import type { GenerationInputsPolymorphicInformationExtractionGenerationInputs } from './GenerationInputsPolymorphicInformationExtractionGenerationInputs';
import {
  GenerationInputsPolymorphicInformationExtractionGenerationInputsFromJSON,
  GenerationInputsPolymorphicInformationExtractionGenerationInputsFromJSONTyped,
  GenerationInputsPolymorphicInformationExtractionGenerationInputsToJSON,
} from './GenerationInputsPolymorphicInformationExtractionGenerationInputs';
import type { GenerationInputsPolymorphicSingleTurnChatGenerationInputs } from './GenerationInputsPolymorphicSingleTurnChatGenerationInputs';
import {
  GenerationInputsPolymorphicSingleTurnChatGenerationInputsFromJSON,
  GenerationInputsPolymorphicSingleTurnChatGenerationInputsFromJSONTyped,
  GenerationInputsPolymorphicSingleTurnChatGenerationInputsToJSON,
} from './GenerationInputsPolymorphicSingleTurnChatGenerationInputs';
import type { GenerationInputsPolymorphicVoiceAgentGenerationInputs } from './GenerationInputsPolymorphicVoiceAgentGenerationInputs';
import {
  GenerationInputsPolymorphicVoiceAgentGenerationInputsFromJSON,
  GenerationInputsPolymorphicVoiceAgentGenerationInputsFromJSONTyped,
  GenerationInputsPolymorphicVoiceAgentGenerationInputsToJSON,
} from './GenerationInputsPolymorphicVoiceAgentGenerationInputs';

/**
 * @type GenerationInputsPolymorphic
 *
 * @export
 */
export type GenerationInputsPolymorphic =
  | ({ taskType: 'conversational_agent' } & GenerationInputsPolymorphicConversationalAgentGenerationInputs)
  | ({ taskType: 'information_extraction' } & GenerationInputsPolymorphicInformationExtractionGenerationInputs)
  | ({ taskType: 'single_turn_chat' } & GenerationInputsPolymorphicSingleTurnChatGenerationInputs)
  | ({ taskType: 'voice_agent' } & GenerationInputsPolymorphicVoiceAgentGenerationInputs);

export function GenerationInputsPolymorphicFromJSON(json: any): GenerationInputsPolymorphic {
  return GenerationInputsPolymorphicFromJSONTyped(json, false);
}

export function GenerationInputsPolymorphicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GenerationInputsPolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['task_type']) {
    case 'conversational_agent':
      return Object.assign(
        {},
        GenerationInputsPolymorphicConversationalAgentGenerationInputsFromJSONTyped(json, true),
        { taskType: 'conversational_agent' } as const,
      );
    case 'information_extraction':
      return Object.assign(
        {},
        GenerationInputsPolymorphicInformationExtractionGenerationInputsFromJSONTyped(json, true),
        { taskType: 'information_extraction' } as const,
      );
    case 'single_turn_chat':
      return Object.assign({}, GenerationInputsPolymorphicSingleTurnChatGenerationInputsFromJSONTyped(json, true), {
        taskType: 'single_turn_chat',
      } as const);
    case 'voice_agent':
      return Object.assign({}, GenerationInputsPolymorphicVoiceAgentGenerationInputsFromJSONTyped(json, true), {
        taskType: 'voice_agent',
      } as const);
    default:
      throw new Error(`No variant of GenerationInputsPolymorphic exists with 'taskType=${json['taskType']}'`);
  }
}

export function GenerationInputsPolymorphicToJSON(value?: GenerationInputsPolymorphic | null): any {
  if (value == null) {
    return value;
  }
  switch (value['taskType']) {
    case 'conversational_agent':
      return GenerationInputsPolymorphicConversationalAgentGenerationInputsToJSON(value);
    case 'information_extraction':
      return GenerationInputsPolymorphicInformationExtractionGenerationInputsToJSON(value);
    case 'single_turn_chat':
      return GenerationInputsPolymorphicSingleTurnChatGenerationInputsToJSON(value);
    case 'voice_agent':
      return GenerationInputsPolymorphicVoiceAgentGenerationInputsToJSON(value);
    default:
      throw new Error(`No variant of GenerationInputsPolymorphic exists with 'taskType=${value['taskType']}'`);
  }
}
